import { defineStore } from 'pinia';
import DealLabelsAPI from 'dashboard/api/dealLabels';

export const useDealLabelsStore = defineStore('dealLabels', {
  state: () => ({
    labels: [],
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  }),

  getters: {
    getLabels: state => state.labels,
    getLabelByTitle: state => title =>
      state.labels.find(l => l.title === title),
    getLabelColorMap: state =>
      Object.fromEntries(state.labels.map(l => [l.title, l.color])),
  },

  actions: {
    async fetchAll() {
      this.isFetching = true;
      try {
        const { data } = await DealLabelsAPI.getAll();
        this.labels = data.payload || [];
      } finally {
        this.isFetching = false;
      }
    },

    async create({ title, color = '#6B7280', description = '' }) {
      this.isCreating = true;
      try {
        const { data } = await DealLabelsAPI.create({
          title,
          color,
          description,
        });
        this.labels.push(data.payload);
        return data.payload;
      } finally {
        this.isCreating = false;
      }
    },

    async update(id, attrs) {
      this.isUpdating = true;
      try {
        const { data } = await DealLabelsAPI.update(id, attrs);
        const idx = this.labels.findIndex(l => l.id === id);
        if (idx !== -1) this.labels[idx] = data.payload;
        return data.payload;
      } finally {
        this.isUpdating = false;
      }
    },

    async delete(id) {
      this.isDeleting = true;
      try {
        await DealLabelsAPI.delete(id);
        this.labels = this.labels.filter(l => l.id !== id);
      } finally {
        this.isDeleting = false;
      }
    },

    async getDealLabels(dealId) {
      const { data } = await DealLabelsAPI.getDealLabels(dealId);
      return data.payload || [];
    },

    async updateDealLabels(dealId, labels) {
      const { data } = await DealLabelsAPI.updateDealLabels(dealId, labels);
      return data.payload || [];
    },
  },
});
